module.exports = __webpack_public_path__ + "static/media/a25.52141f94.pdf";